"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwShellTopNav = _interopRequireDefault(require("./CwShellTopNav.scss"));

var CwShellTopNav = function CwShellTopNav(props) {
  return _react.default.createElement("div", {
    className: _CwShellTopNav.default.cwShellTopNav,
    style: props.style
  }, props.children);
};

CwShellTopNav.propTypes = {
  children: _propTypes.default.any,

  /**
   * Allows custom styling
   */
  style: _propTypes.default.object
};
var _default = CwShellTopNav;
exports.default = _default;